function ErrorFallback() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center px-4">
        <h1 className="text-2xl font-bold mb-2 text-gray-900">Something went wrong</h1>
        <p className="text-gray-600 mb-4">
          We've been notified and are looking into it.
        </p>
        <button
          onClick={() => {
            window.location.href = '/';
          }}
          className="px-4 py-2 bg-amber-700 text-white rounded hover:bg-amber-800"
        >
          Go Home
        </button>
      </div>
    </div>
  );
}

export default ErrorFallback;
